document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".c-video-link__wrapper video");
  let loadedVideos = 0;

  // 動画の読み込みを待つ関数
  function waitForVideoLoad(video) {
    return new Promise((resolve) => {
      if (video.readyState >= 3) {
        resolve();
      } else {
        video.addEventListener("canplaythrough", resolve, { once: true });
      }
    });
  }

  // 全ての動画の準備ができたら再生
  Promise.all(Array.from(videos).map(waitForVideoLoad)).then(() => {
    videos.forEach((video) => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Video failed to play:", error);
        });
      }
    });
  });
});
